<div class="c-modal__content">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
